import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import './index.css';

import { useNavigate } from "react-router-dom";
import { useAuth } from 'fennec-ui';

// or 'antd/dist/antd.less'

import locale from 'antd/es/date-picker/locale/ru_RU';
import Icofont from 'react-icofont';

import {
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  DatePicker,
  message,
  Typography
} from 'antd';
import InputPhone from "./input-phone";
import confirm from 'antd/lib/modal/confirm';

const { Text, Link } = Typography;

const { Option } = Select;


function String({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/\s/g, '');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function StringEe({ value, onChange }) {
  return (
    <Input allowClear value={value} onChange={(v) => {
      let val = v.target.value
      if (val) {
        val = val.replace(/Ё/g, 'E').replace(/ё/g, 'e');
      }
      onChange(val)
    }
    } style={{ width: "100%" }} />
  )
}

function Signup(props) {
  let navigate = useNavigate();
  const auth = useAuth();

  const formRef = React.createRef();

  const [confirmDirty, setConfirmDirty] = React.useState(false)
  const [gender, setGender] = React.useState([])
  const [recaptchaSite, setRecaptchaSite] = React.useState("")

  let captcha = undefined;

  React.useEffect(() => {
    auth.fetch('/api/recaptcha/site').then(res => {
      if (res && res.data) {
        setRecaptchaSite(res.data);
      }
    });

    auth.fetch('/api/query/gender?s-name=desc').then(res => {
      if (res && res.data) {
        setGender(res.data);
      }
    });
  }, [])

  const handleSubmit = React.useCallback((values) => {
    confirm({
      title: <span><Icofont icon="exclamation-circle" style={{ color: "orange" }} /> Регистрация</span>,
      icon: undefined,
      content: <span style={{ fontSize: "13px" }}>ВНИМАНИЕ! Убедитесь что Вы указали правильный пол в форме регистрации,
        т.к. указанный Вами пол (<span style={{ fontWeight: "600" }}>{(values.genderID == "1") ? "Мужской" : "Женский"}</span>) влияет на дальнейшее участие в соревнованиях и не может быть изменен самостоятельно!</span>,
      okText: 'Все верно!',
      cancelText: 'Отмена',
      onOk() {
        auth.signup(values)
          .then(res => {
            if (!res.status) {
              if (captcha) {
                captcha.reset();
              }
              //Валидация (подумать как сделать универсально)
              //Чистим ошибки предыдущей валидации
              formRef.current.setFieldsValue(formRef.current.getFieldsValue());
              //Показываем новые ошибки
              if (res.invalid && res.invalid.errors) {
                var object = res.invalid.errors
                for (const key in object) {
                  if (object.hasOwnProperty(key)) {
                    const element = object[key];
                    if (element && element.length) {
                      var valData = [];
                      valData.push({
                        name: key,
                        errors: [element[0].message],
                        value: (element[0].value) ? element[0].value : ""
                      })
                      formRef.current.setFields(valData);
                    }
                  }
                }
              }
              message.error(res.message);
            } else {
              auth.redirect(res);
            }
          })
          .catch(err => {
            if (captcha) {
              captcha.reset();
            }
            console.log(err)
          })
      },
      onCancel() {
      },
    })
  }, [captcha, formRef])

  const handleConfirmBlur = (e) => {
    const { value } = e.target;
    setConfirmDirty(confirmDirty || !!value);
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  const genderOption = gender.map((d) => <Option key={d.ID}>{d.name}</Option>);
  return (
    <div style={{
      height: "calc(100vh - 12px)",
      backgroundColor: (props.mobile) ? "white" : "#f5f5f5",
      margin: "5px",
      borderRadius: "5px"
    }}>

      <div className="register-form" style={{ paddingBottom: "0px", textAlign: "center", maxWidth: (props.mobile) ? "300px" : "600px" }}>
        <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
          <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
        </a>
      </div>

      <Form ref={formRef} name="register" {...formItemLayout}
        onFinish={handleSubmit}
        onFinishFailed={({ errorFields }) => {
          formRef.current.scrollToField(errorFields[0].name);
        }}
        className="register-form"
        style={{ maxWidth: (props.mobile) ? "300px" : "600px", paddingTop: "5px" }}

        initialValues={{
          // genderID: '1',
          tipTelefonaID: '1',
        }}
      >
        <div style={{
          backgroundColor: "white",
          padding: (props.mobile) ? "0px" : "25px",
          boxShadow: "1px 1px 8px 0px rgba(34, 60, 80, 0.2)",
          borderRadius: "5px"
        }}>
          <Form.Item label="Адрес электронной почты"
            name="email"
            rules={[
              {
                type: 'email',
                message: 'Введен неверный адрес электронной почты!',
              },
              {
                required: true,
                message: 'Пожалуйста, введите свой адрес электронной почты!',
              },
            ]}
          >
            <String />
          </Form.Item>
          <Form.Item label="Пароль" hasFeedback
            name="password"
            rules={[
              {
                required: true,
                message: 'Пожалуйста, введите пароль не меньше 8 символов!',
              },
              {
                min: 8,
                message: 'Пожалуйста, введите пароль не меньше 8 символов!',
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item label="Повторите пароль" hasFeedback
            name="confirm"
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: 'Пожалуйста, повторите ваш пароль!',
              },
              {
                min: 8,
                message: 'Пожалуйста, повторите ваш пароль!',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Пароли не совпадают!');
                },
              }),
            ]}
          >
            <Input.Password onBlur={handleConfirmBlur} />
          </Form.Item>

          <Form.Item label={"Фамилия"}
            name="lastname"
            rules={[{ required: true, message: 'Пожалуйста, введите фамилию!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label={"Имя"}
            name="firstname"
            rules={[{ required: true, message: 'Пожалуйста, введите имя!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label={"Отчество"}
            name="patronymic"
          >
            <Input />
          </Form.Item>
          <Form.Item label={"Дата рождения"}
            name="birthday"
            rules={[{ required: true, message: 'Пожалуйста, введите дату рождения!' }]}
          >
            <DatePicker format="DD.MM.YYYY" locale={locale} />
          </Form.Item>

          <Form.Item label="Пол"
            name="genderID"
            rules={[{ required: true, message: 'Пожалуйста, укажите пол!' }]}
          >
            <Select defaultActiveFirstOption={false}>
              {genderOption}
            </Select>
          </Form.Item>

          <Form.Item label={"Телефон"}
            name="phone"
            rules={[
              { required: true, message: 'Пожалуйста, введите телефон!' },
              { pattern: /\d{8,}/g, message: 'Пожалуйста, введите телефон!' }
            ]}
          >
            <InputPhone />
          </Form.Item>

          {(auth.appProfile == "prod") && <Form.Item {...tailFormItemLayout}
            name="captcha"
            rules={[{ required: true, message: 'Мы должны убедиться, что вы человек!' }]}
          >
            <ReCAPTCHA
              ref={e => (captcha = e)}
              sitekey={recaptchaSite}
            />
          </Form.Item>}

          <Form.Item {...tailFormItemLayout}
            name="agreement"
            valuePropName="checked"
            rules={[{
              validator: (_, value) => value ? Promise.resolve() : Promise.reject('Вы должны согласиться с условиями!')
            }]}
          >
            <Checkbox>
              Вам необходимо поставить «галочку», подтвердив тем самым, что Вы
              принимаете условия <a target="_blank" rel="noopener noreferrer" href="https://social-dance.club/fed/about/user-agreement">Пользовательского соглашения</a>,
              ознакомлены и согласны с <a target="_blank" rel="noopener noreferrer" href="https://social-dance.club/fed/about/privacy-policy"> Политикой конфиденциальности</a>.
            </Checkbox>

          </Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Регистрация
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
}

// const Signup = Form.create({ name: 'register' })(RegistrationForm);
export default Signup;